import Link from 'next/link';
import { FC } from 'react';

import { Anchor } from '@mantine/core';

import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { CollateralTeaserGrid } from 'components/collateral/CollateralTeaserGrid';
import { useCollateralItems } from 'components/company-profile/hooks/use-collateral-items';
import { Section } from 'components/section/Section';

const Collateral: FC<{ company: CompanyProfile }> = ({ company }) => {
    const { items } = useCollateralItems(company);

    if (!items.length) {
        return null;
    }

    return (
        <Section title="Collateral" id="collateral">
            <CollateralTeaserGrid items={items} />

            {items.length > 4 && (
                <Anchor
                    component={Link}
                    href={CompanyHelpers.urls.collateral(company.slug)}
                    size="md"
                    fw={600}
                    c="black"
                >
                    View all collateral
                </Anchor>
            )}
        </Section>
    );
};

export { Collateral };
